import React from 'react';
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { FaFacebookF, FaGoogle, FaLinkedinIn, FaPinterest, FaXTwitter } from "react-icons/fa6";
import main_logo from '../assets/images/main_logo.png';
import { useNavigate } from "react-router-dom";

function Footer() {
    const navigate = useNavigate();

    const goToContact = (pageName) => {
        if (pageName === "colleges") {
            navigate("/college_listing", { state: { scrollTo: pageName } });
        }
        else if (pageName === "blog") {
            navigate("/blog", { state: { scrollTo: pageName } });
        }
        else if (pageName === "privacy") {
            navigate("/privacy-policy", { state: { scrollTo: pageName } });
        }
        else if (pageName === "terms") {
            navigate("/terms-conditions", { state: { scrollTo: pageName } });
        }
        else if (pageName === "advertise") {
            navigate("/advertise", { state: { scrollTo: pageName } });
        }
        else if (pageName === "ambassador") {
            navigate("/campus-ambassador", { state: { scrollTo: pageName } });
        }
        else if (pageName === "question-answer") {
            navigate("/question-answer", { state: { scrollTo: pageName } });
        }
        else if (pageName === "scholarship-index") {
            navigate("/scholarship-index", { state: { scrollTo: pageName } });
        }
        else if (pageName === "exam-index") {
            navigate("/exam-index", { state: { scrollTo: pageName } });
        }
        else if (pageName === "about-us") {
            navigate("/about-us", { state: { scrollTo: pageName } });
        }
        else if (pageName === "contact-us") {
            navigate("/contact-us", { state: { scrollTo: pageName } });
        }
        else {
            navigate("/", { state: { scrollTo: pageName || "home" } });
        }
    };

    return (
        <div className="section footersec-st" >
            <footer className="footer">
                <div className="footer-container">
                    {/* LEFT */}
                    <div className="footer-about">
                        <img src={main_logo} alt="main_logo" className="img-mainst logofootmb-st" style={{ maxWidth: "100%", width: "auto" }} />
                        <p className='footchinfo-st'>
                            An educational support platform helping students make informed decisions about their academic and career paths. ISO 9001:2015 Certified.
                        </p>
                    </div>

                    {/* QUICK LINKS */}
                    <div className='quicklink-st'>
                        <div className='quicklink-stsub'>
                            <h5 className='qklink-st'>Quick Links & Legal</h5>
                            <ul>
                                <li onClick={() => goToContact("home")} >Home</li>
                                <li onClick={() => goToContact("colleges")}>Colleges</li>
                                <li onClick={() => goToContact("course")}>Courses</li>
                                <li onClick={() => window.location.href = "https://campushunt.in/blog/"}>Blogs</li>
                                <li onClick={() => goToContact("privacy")}>Privacy Policy</li>
                                <li onClick={() => goToContact("terms")}>Terms & Condition</li>
                                <li onClick={() => goToContact("about-us")}>About Us</li>
                                <li onClick={() => goToContact("contact-us")}>Contact Us</li>
                            </ul>
                        </div>

                        {/* ABOUT */}
                        <div className='quicklink-stsub'>
                            <h5 className='qklink-st'>Company</h5>
                            <ul>
                                <li onClick={() => goToContact("advertise")}>AdvertiseWith Us</li>
                                <li onClick={() => goToContact("ambassador")}>Campus Ambassador</li>
                                <li>Distance Education</li>
                            </ul>

                            <h5 className='qklink-st'>Resources</h5>
                            <ul>
                                <li onClick={() => goToContact("exam-index")}>Exams</li>
                                <li onClick={() => goToContact("scholarship-index")}>Scholarships </li>
                                <li onClick={() => goToContact("question-answer")}>Q&A</li>
                            </ul>
                        </div>
                    </div>

                    <div className="footer-contact">
                        <h5>Reach us</h5>
                        <p className="p-footer"><FaPhoneAlt />+91 9108703683</p>
                        <p className="p-footer"><FaEnvelope />info@campushunt.in</p> <br />
                        <p className="p-footer-r">ISO 9001:2015 Certified</p>
                        <hr className="foor-hr" />
                    </div>
                </div>
            </footer>

            <div className="ch-footer-bottom">
                <p>© 2026 CampusHunt. All Rights Reserved.</p>
                <div className="ch-social">
                    <a href="https://x.com/CampusHunt_in"><FaXTwitter /></a>
                    <a href="https://www.facebook.com/campushunt.in?ref=aymt_homepage_panel"><FaFacebookF /></a>
                    <a href="https://workspaceupdates.googleblog.com/2023/04/new-community-features-for-google-chat-and-an-update-currents%20.html"><FaGoogle /></a>
                    <a href="https://www.linkedin.com/login/?session_redirect=%2Fcompany%2F13445015%2F"><FaLinkedinIn /></a>
                    <a href="https://in.pinterest.com/campushunt/"><FaPinterest /></a>
                </div>
            </div>
        </div>
    )
}

export default Footer
